module.exports = __webpack_public_path__ + "img/r-rachel-park-366508-unsplash-min-460x295.296f60d0.jpg";